/** In-place edits to the notification inbox cache (no refetch). */
import type { QueryClient } from "@tanstack/react-query";
import type { AppNotification } from "./api";
import { NOTIFICATIONS_QUERY_KEY } from "./query-keys";

type Inbox = { ok: true; notifications: AppNotification[]; unread: number };

export function addNotification(queryClient: QueryClient, notification: AppNotification): void {
    queryClient.setQueryData<Inbox>(NOTIFICATIONS_QUERY_KEY, current => {
        if (!current || current.notifications.some(item => item.id === notification.id)) return current;
        return {
            ...current,
            notifications: [notification, ...current.notifications],
            unread: current.unread + (notification.readAt ? 0 : 1),
        };
    });
}

/** Mark read (or dismiss) by id, or everything when `ids` is null. */
export function patchNotificationState(queryClient: QueryClient, change: { ids: string[] | null; dismissed: boolean; at: string }): void {
    queryClient.setQueryData<Inbox>(NOTIFICATIONS_QUERY_KEY, current => {
        if (!current) return current;
        const hit = (item: AppNotification) => change.ids === null || change.ids.includes(item.id);
        const notifications = change.dismissed
            ? current.notifications.filter(item => !hit(item))
            : current.notifications.map(item => hit(item) && !item.readAt ? { ...item, readAt: change.at } : item);
        return { ...current, notifications, unread: notifications.filter(item => !item.readAt).length };
    });
}
